// Administrative Skills organized by subcategories
export const ADMINISTRATIVE_SKILLS_CATEGORIES = [
  {
    name: 'Office Management',
    skills: [
      'Office Coordination', 'Facility Management', 'Supply Management',
      'Vendor Relations', 'Space Planning', 'Equipment Maintenance',
      'Office Budget', 'Staff Supervision', 'Policy Implementation',
      'Process Improvement', 'Resource Allocation', 'Safety Compliance',
      'Emergency Planning', 'Access Control', 'Workplace Organization'
    ]
  },
  {
    name: 'Document Management',
    skills: [
      'Filing Systems', 'Records Management', 'Document Control',
      'Digital Archives', 'Data Entry', 'Document Processing',
      'Version Control', 'Information Retrieval', 'Document Security',
      'Compliance Documentation', 'Quality Control', 'Audit Support',
      'Retention Policies', 'Document Workflows', 'System Organization'
    ]
  },
  {
    name: 'Communication Management',
    skills: [
      'Email Management', 'Phone Systems', 'Correspondence',
      'Meeting Coordination', 'Calendar Management', 'Client Relations',
      'Internal Communications', 'External Communications', 'Message Handling',
      'Communication Protocols', 'Information Flow', 'Feedback Collection',
      'Status Updates', 'Report Distribution', 'Communication Tools'
    ]
  },
  {
    name: 'Schedule Management',
    skills: [
      'Calendar Coordination', 'Appointment Setting', 'Travel Planning',
      'Event Planning', 'Meeting Organization', 'Time Management',
      'Priority Setting', 'Resource Scheduling', 'Conflict Resolution',
      'Schedule Optimization', 'Deadline Management', 'Follow-up Systems',
      'Reminder Systems', 'Schedule Tracking', 'Calendar Software'
    ]
  },
  {
    name: 'Data Management',
    skills: [
      'Database Management', 'Data Entry', 'Data Verification',
      'Data Organization', 'Report Generation', 'Data Analysis',
      'Information Systems', 'Data Security', 'Quality Control',
      'System Updates', 'Data Backup', 'Error Resolution',
      'Data Cleaning', 'Data Integration', 'Performance Tracking'
    ]
  },
  {
    name: 'Financial Administration',
    skills: [
      'Budget Tracking', 'Expense Management', 'Invoice Processing',
      'Payment Processing', 'Account Reconciliation', 'Financial Reports',
      'Purchase Orders', 'Cost Control', 'Financial Records',
      'Audit Support', 'Compliance Checking', 'Budget Planning',
      'Financial Software', 'Vendor Payments', 'Financial Documentation'
    ]
  },
  {
    name: 'Project Support',
    skills: [
      'Project Coordination', 'Task Management', 'Resource Allocation',
      'Timeline Tracking', 'Status Reporting', 'Team Support',
      'Document Preparation', 'Meeting Support', 'Action Items',
      'Progress Monitoring', 'Risk Tracking', 'Issue Resolution',
      'Project Documentation', 'Stakeholder Updates', 'Project Tools'
    ]
  },
  {
    name: 'Customer Service',
    skills: [
      'Client Support', 'Inquiry Handling', 'Problem Resolution',
      'Service Coordination', 'Feedback Management', 'Client Relations',
      'Quality Assurance', 'Service Standards', 'Response Management',
      'Client Records', 'Service Tracking', 'Satisfaction Monitoring',
      'Issue Escalation', 'Service Innovation', 'Client Communication'
    ]
  },
  {
    name: 'Process Improvement',
    skills: [
      'Workflow Analysis', 'Process Documentation', 'Efficiency Enhancement',
      'Standard Operating Procedures', 'Best Practices', 'Quality Control',
      'Process Testing', 'Change Implementation', 'Training Support',
      'Performance Metrics', 'Process Automation', 'Continuous Improvement',
      'Process Integration', 'System Optimization', 'Innovation Implementation'
    ]
  },
  {
    name: 'Compliance Management',
    skills: [
      'Policy Implementation', 'Regulatory Compliance', 'Standard Adherence',
      'Audit Support', 'Documentation Control', 'Compliance Monitoring',
      'Risk Management', 'Safety Protocols', 'Quality Standards',
      'Training Coordination', 'Compliance Reporting', 'Issue Resolution',
      'Policy Updates', 'Compliance Tools', 'Performance Tracking'
    ]
  },
  {
    name: 'Technology Support',
    skills: [
      'Software Management', 'System Administration', 'Technical Support',
      'User Training', 'Equipment Maintenance', 'Software Updates',
      'Technology Integration', 'System Security', 'Data Backup',
      'User Access', 'Problem Resolution', 'Technology Planning',
      'System Documentation', 'Performance Monitoring', 'Innovation Adoption'
    ]
  },
  {
    name: 'Team Support',
    skills: [
      'Staff Coordination', 'Team Communication', 'Resource Management',
      'Training Support', 'Performance Monitoring', 'Team Building',
      'Conflict Resolution', 'Motivation Support', 'Team Development',
      'Goal Setting', 'Progress Tracking', 'Recognition Programs',
      'Team Documentation', 'Feedback Systems', 'Team Innovation'
    ]
  },
  {
    name: 'Quality Management',
    skills: [
      'Quality Control', 'Standard Implementation', 'Performance Monitoring',
      'Quality Metrics', 'Process Improvement', 'Documentation Control',
      'Audit Support', 'Compliance Checking', 'Issue Resolution',
      'Quality Planning', 'Training Support', 'Innovation Management',
      'Quality Tools', 'Performance Analysis', 'Continuous Improvement'
    ]
  },
  {
    name: 'Resource Management',
    skills: [
      'Supply Management', 'Inventory Control', 'Resource Allocation',
      'Asset Tracking', 'Cost Control', 'Vendor Management',
      'Resource Planning', 'Budget Management', 'Efficiency Enhancement',
      'Resource Documentation', 'Performance Analysis', 'Process Improvement',
      'Resource Tools', 'Innovation Planning', 'Sustainability Practices'
    ]
  },
  {
    name: 'Administrative Leadership',
    skills: [
      'Team Leadership', 'Process Direction', 'Resource Management',
      'Performance Management', 'Strategic Planning', 'Innovation Leadership',
      'Change Management', 'Quality Assurance', 'Staff Development',
      'Decision Making', 'Problem Solving', 'Risk Management',
      'Success Planning', 'Growth Strategy', 'Future Planning'
    ]
  }
];

// Export flattened list for backward compatibility
export const ADMINISTRATIVE_SKILLS = ADMINISTRATIVE_SKILLS_CATEGORIES.reduce(
  (acc, category) => [...acc, ...category.skills],
  [] as string[]
);
